import script from "./FileResizableDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileResizableDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./FileResizableDropdown.vue?vue&type=style&index=0&id=2645408e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2645408e"]])

export default __exports__